import { Box } from '@mui/material';
import PaywallJoinThousands from '../../javascript/images/PaywallJoinThousandsCompressed.png'
import MarketProLogo from '../../javascript/images/MarketProLogo.png'
import "../../stylesheets/chat_page.css"
import { useState, useEffect } from 'react';
import PaywallButton from './Mui/PaywallButton';
import { useNavigate } from 'react-router-dom';
import { isMobileBrowser } from '../utils/user_agent';

const PastDueModal = ({ 
  setShowPastDueModal,
  isSidebarOpen,
}) => {

  const navigate = useNavigate()

  const [opacity, setOpacity] = useState(0)
  const handleClose = () => {
    setShowPastDueModal(false); // Hide modal
    // setShowPaywallAfter(false); // won't default to showing after sign up modal close.
  };

  const isMobile = isMobileBrowser()

  useEffect(() => {
    setOpacity(1.0)
  }, [])

  const openCustomerPortal = async (flow='', return_url='') => {
    const res  = await fetch(`/stripe_customer_portal?flow=${flow}&return_url=${return_url}`, {
      method: 'POST'
    });
    const data = await res.json();
    if (data.url) window.location.href = data.url;
  };

  return (
    <div className="modal modal-paywall" style={{
      paddingLeft: '300px',
      // backgroundColor: 'red',
      opacity: opacity,
      transition: 'opacity 1.0s',
      }}>
      <div className="paywall-modal-content" style={{
        marginLeft: (!isMobile && isSidebarOpen) ? '150px':'unset',
      }}>
        
        <Box className="base-text" sx={{
          fontSize: '15px', color: '#2971D7', fontWeight: '500', 
          position: 'absolute', top: '20px', left: '20px', '&:hover': {cursor: 'pointer'}}} onClick={handleClose}
        >
          Close
        </Box>

        <Box className="base-text" sx={{gap: '0px', marginBottom: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontWeight: '500', fontSize: '36px'}}>
          <img src={MarketProLogo} style={{width: '32px'}} className="logo-img" alt="IncitePlus Logo" />
          <Box className="header-paywall-modal" sx={{fontWeight: '600', color: '#1D1D1F'}}>
            Incite AI
          </Box>
        </Box>

        <Box className="base-text" sx={{margin: '0px auto 0px auto', fontWeight: '500', fontSize: '17px', lineHeight: '150%',}}>
          Real Time Intelligence
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
          <Box className="base-text" sx={{textAlign: 'left', marginTop: '20px', marginBottom: '26px', fontWeight: '500', fontSize: '14px', maxWidth: '85%', lineHeight: '150%', color: '#FD0707'}}>
            Your subscription is past due and paid<br/>features are paused. Please update your<br/>payment method to restore access.
          </Box>
        </Box>

        <Box sx={{width: '260px', margin: '0px auto', maxWidth: '86%', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <PaywallButton 
            // onClick={() => onClickAction()}
            onClick={() => openCustomerPortal('update-payment', 'chat')}
          >
            <Box sx={{width: '100%', ontWeight: '500', fontSize: '14px', margin: '6px auto',}}>
                {'Update Payment Method'}
            </Box>
          </PaywallButton>
        </Box>

        <Box sx={{marginTop: '22px', width: '100%'}}>
          <img src={PaywallJoinThousands} style={{maxWidth: '100%'}}/>
        </Box>

      </div>
    </div>
  )
}

export default PastDueModal
